module.exports = __webpack_public_path__ + "img/1960_uk.a6a27d65.svg";